import { useReducer, useEffect } from 'react';
import getVIN from '../data/vin';

const LOADING_ACTION = 'loading';
const SUCCESS_ACTION = 'success';
const ERROR_ACTION = 'error';

function reducer(state, action) {
  switch(action.type) {
    case LOADING_ACTION:
      return { ...state, loading: true, loaded: false, vin: action.prop, error: undefined };
    case SUCCESS_ACTION:
      return { ...state, loading: false, loaded: true, ...action.prop, error: undefined };
    case ERROR_ACTION:
      return { ...state, loading: false, loaded: false, error: action.prop };
    default:
      throw new Error('useVehicle: unknown action');
  }
}

function useVIN(initVIN) {
  const [state, dispatch] = useReducer(reducer, { loading: false, loaded: false, error: undefined, vin: initVIN });
  useEffect(() => {
    async function run() {
      dispatch({ type: LOADING_ACTION, prop: state.vin });
      try {
        const { yearId, makeId, modelId, trimId } = await getVIN(state.vin);
        dispatch({ type: SUCCESS_ACTION, prop: { yearId, makeId, modelId, trimId } });
      } catch(err) {
        dispatch({ type: ERROR_ACTION, prop: err });
      }
    }

    if (state.vin) {
      run();
    }
  }, [state.vin])

  const setVIN = () => {
    console.warn('useVIN: setVIN not implemented');
  };

  return [state, setVIN];
}

export default useVIN;
